import type { OperationVariables } from '@apollo/client'
import type { UseLazyQueryReturn } from '@vue/apollo-composable'

export const loadOrRefetch = async <Result, Variables extends OperationVariables>(
  load: UseLazyQueryReturn<Result, Variables>['load'],
  refetch: UseLazyQueryReturn<Result, Variables>['refetch'],
  variables?: Variables,
) => {
  const response = await load(null, variables)
  if (response !== false) return response

  const refetchResponse = await refetch(variables)
  return refetchResponse?.data
}
